import { Spinner } from "@/components/ui/spinner";

function SpinnerPage(props: React.ComponentProps<"svg">) {
  return (
    <div className="flex h-screen w-full items-center justify-center">
      <Spinner {...props} />
    </div>
  );
}

export { SpinnerPage };
